import useEditCharacterCount from '../composables/useEditCharacterCount'
//------------------------------
// edit character counts harness
//------------------------------
export default async function useEditCharacterCountsHarness(changed_counts) {
  console.log('---------------------------------------')
  console.log('IN useEditCharacterCountsHarness')
  //-------------------------------------------
  // manages all character count updates (CRUD)
  //-------------------------------------------
  //--------------------------------------
  // create promise for each count update
  //--------------------------------------
  const promises = changed_counts.map((r) => {
    console.log('IN useEditCharacterCountsHarness - PROCESSING COUNT:', r)
    //-------------------
    // call api function
    //-------------------
    return useEditCharacterCount(r)
  })
  //------------------------------------------------------------
  // wait for all updates to complete - let errors propagate up
  //------------------------------------------------------------
  // const results = await Promise.all(promises)
  await Promise.all(promises)
  //-----------------------------
  // optionally return responses
  //-----------------------------
  // if (returnResponses) return results
  // return results
  //----------------------------------------------
  // else no response (caller awaited completion)
  //----------------------------------------------
  return
}
